export default [
    {
        id: 1,
        name: "Omlazení pleti",
        text: `<h3>OMLAZENÍ PLETI</h3> 
           <strong>Fotofacial, Ulthera, LPG Liftmassage, N-lite, ResurFx, Mechanický peeling, Natural skinlift, Regen Plazma, Hydrolift</strong> <br/>
           V estetické a laserové medicíně je velkou výhodou možnost <strong>kombinace</strong> těchto zákroků dle individuální potřeby klienta. Kombinace přináší znásobení výsledného efektu omlazení a tím i Vaší spokojenosti s ošetřením, než kdyby se prováděly samostatně.
           Vějířky kolem očí, rtů či na čele, hluboké vrásky nebo povadlá kůže v obličeji, jizvy po akné či úrazu, všechny tyto projevy stárnutí kůže lze zmírnit nebo dokonce odstranit. <br/><br/>
           <h3>FOTOFACIAL</h3><br/>
           Vrásky, jizvičky po akné, rozšířené póry, pigmentové skvrnky nebo rozšířené žilky, které vytváří mapy či načervenalý vzhled obličeje, trápí mnoho našich pacientů. Na naší klinice umíme všechny tyto problémy vyřešit velmi jednoduchou komplexní metodou <strong>FOTOFACIAL</strong>, česky řečeno opětovné vyčištění pleti pomocí pulsů intenzivního světla. <br/>
           Světelný puls roztříští pigmentové skvrnky, pigment se následně vylučuje na povrch v podobě šupinek, které se olupují stejně jako šupinky staré kůže. Zároveň dochází k zatavení a následnému vstřebání rozšířených žilek. V kůži navíc dochází ke stimulaci tvorby kolagenních vláken pro regeneraci kůže a k vyhlazení drobných vrásek. Efekt je okamžitý a žilky mizí přímo před očima. Kůže se projasní a pročistí, vypadá svěže a daleko méně se mastí. Zákrok je minimálně bolestivý, po ošetření může kůže lehce zčervenat, tento projev však během několika minut až hodin zmizí.`,
        types: [
            {
                name: "Fotofacial - podle velikosti ošetřované plochy",
                price: "2 000 - 5 000 Kč",
            }, {
                name: "Ulthera - neinvazivní metoda Facelift - celý obličej",
                price: "36 000 Kč a více",
            }, {
                name: "Ulthera - neinvazivní metoda Facelift - 2/3 obličeje",
                price: "24 000 - 36 000 Kč",
            }, {
                name: "Ulthera - neinvazivní metoda Facelift - 1/3 obličeje",
                price: "12 000 - 18 000 Kč",
            }, {
                name: "LPG Liftmassage - do 30 min",
                price: "500 Kč",
            }, {
                name: "N-Lite",
                price: "od 3000 Kč",
            }, {
                name: "ResurFX - nad horním rtem",
                price: "1 000 - 2 000 Kč",
            }, {
                name: "ResurFX - čelo",
                price: "2 000 - 3 000 Kč",
            }, {
                name: "ResurFX - kolem očí",
                price: "3 000 - 4 000 Kč",
            }, {
                name: "ResurFX - kolem očí až na líce",
                price: "4 000 - 5 000 Kč",
            }, {
                name: "ResurFX - obličej dolní 2/3 bez dolních víček",
                price: "4 000 - 5 000 Kč",
            }, {
                name: "ResurFX - krk",
                price: "4 000 - 5 000 Kč",
            }, {
                name: "ResurFX - celý obličej",
                price: "8 000 - 10 000 Kč",
            }, {
                name: "ResurFX - dekolt",
                price: "5 000 - 6 000 Kč",
            }, {
                name: "ResurFX - ruce - 1 ruka",
                price: "2 000 - 3 000 Kč",
            }, {
                name: "ResurFX - ruce - obě",
                price: "4 000 - 6 000 Kč",
            }, {
                name: "Mechanický peeling",
                price: "1 000 Kč",
            }, {
                name: "Natural skinlift",
                price: "7 000 - 14 000 Kč",
            }, {
                name: "Hydrolift - celá procedura (4 ošetření)",
                price: "18 000 Kč",
            }, {
                name: "Hydrolift - jednotlivý zákrok",
                price: "5 000 Kč",
            },

        ],
        doctors: [
            4, 5, 6, 7, 10, 12
        ]
    },

    {
        id: 2,
        name: "Vyhlazení vrásek - injekční metody",
        text: `<h3>BOTULOTOXIN</h3><br/>
           Střední vrásky v oblasti kolem očí a na čele odstraňujeme injekční metodou pomocí látky botulotoxin. Ten aplikujeme do lokality, kde se vrásky tvoří. Jedná se o látku, která působí jako elektrický vypínač. Mimický sval, tvořící na kůži vrásku, se jednoduše vypne, a tím pádem se kůže vyrovná. Účinnost první injekce nastává již po několika hodinách a trvá až 6 měsíců. Po opakované aplikaci jsou již vrásky vyhlazeny na delší dobu. <br/><br/>
           <h3>INJEKČNÍ VÝPLŇOVÉ MATERIÁLY</h3><br/>
           Na hlubší vrásky používáme tzv. metodu objemového vyplňování. Jde opět o aplikaci látky do kůže pomocí injekce. Aplikovaná látka působí jako objemový vyplňovač, který vpadlé místo v kůži nadzvedne a vyrovná. Celý zákrok je velmi rychlý, bezbolestný a vysoce účinný. Navíc je oproti chirurgickému zákroku pro pacienta minimálně zátěžový. Výhodou je i to, že námi aplikované materiály nevyvolávají běžně žádné alergické reakce, na rozdíl od podobných zákroků s aplikací kolagenu. Zcela excelentně se tato metoda uplatňuje v objemovém zvětšování rtů, které tak dostávají mladistvější a plnější výraz nebo u vyplňování nosoretních vrásek, či vrásek kolem úst. <br/><br/>
           <h3>PLAZMATERAPIE - REGENPLAZMA</h3><br/>
           K ošetření se používá plazma získaná z vlastní krve pacienta. <br/><br/> 
           <h3>MEZOLIFT</h3>
           Speciální technika, která se používá v boji proti prvním příznakům stárnutí kůže nebo revitalizaci zralé pleti a jako doplněk plasticko-chirurgických operací, dále při řešení hlubokých vrásek po laserovém broušení. Pomocí mikroinjekcí je aplikován do kůže a podkoží speciální vitamínový koktejl obohacený o antioxidanty, enzymy, stopové prvky a kyselinu hyaluronovou. Výsledkem je zvýšená hydratace a stimulace tvorby kolagenu. Metodu je možné provádět v obličeji, krku, dekoltu a vrchních částech rukou. Schéma ošetření se určuje individuálně podle typu poškození kůže. Vhodná jsou 4 sezení s odstupem jednoho týdne až měsíce. V ceně jednoho ošetření je možno ošetřit najednou např.: celý obličej, krk a část dekoltu nebo celý obličej a horní část rukou. <br/><br/> 
           <h3>NATURAL SKINLIFT</h3><br/>
           Natural skinlift je úžasnou novinkou mezi technikami omlazování a hydratování kůže v oblasti estetické chirurgie. Tento styl aplikace kyseliny hyaluronové umožňuje lékaři kvalitní a zároveň bezpečné plošné ošetření dané lokality a tím následné vypnutí vrásek. Natural skinlift je „pistole“,  která se přikládá na kůži a tu pod tlakem nasaje. Poté z hlavice přístroje vystřelí pět jehliček a vpraví do cílené ošetřované kožní plochy kyselinu hyaluronovou. Tato metoda umožňuje dokonalou celoplošnou hydrataci, jelikož je kyselina hyaluronová naprosto rovnoměrně rozložena. Efekt po zákroku je okamžitý, mohou se však vytvořit malé modřinky, které vymizí během několika dní po provedení zákroku.`,
        types: [
            {
                name: "Botulotoxin",
                price: "3 000 - 6 000 Kč",
            }, {
                name: "injekční výplně vrásek",
                price: "4 000 - 10 000 Kč",
            }, {
                name: "Plazmaterapie - Regenplazma",
                price: "4 500 - 12 000 Kč",
            }, {
                name: "Mezolift",
                price: "5 000 Kč",
            }, {
                name: "Natural skinlift",
                price: "7 000 - 14 000 Kč",
            }
        ],
        doctors: [
            4, 5, 6, 7, 10, 12
        ]
    },

    {
        id: 3,
        name: "Zvětšení rtů - injekční metody",
        text: `Rty jsou v obličeji bezesporu dominantou. Úzký ret nebo vrásky nad ním jsou častým steskem našich pacientek a musíme uznat, že celkovému vzhledu obličeje ubližují a nedodávají mu mladistvý a plný výraz. <br/>
           Ke zvětšování nebo vyplňování rtů většinou používáme metodu injekční, kdy se do tkáně rtu vpravuje látka, která slouží jako objemový vyplňovač. Ta dodá rtům plný tvar a vyhladí také drobné vrásky. Trvanlivost takového zákroku je závislá na druhu aplikované látky. Může působit  zhruba 2 až 3 roky, občas i více let. Používáme ale také materiály nevstřebatelné, které zaručují trvalý efekt.`,
        types: [
            {
                name: "injekční metody",
                price: "8 000 - 10 000 Kč",
            },
        ],
        doctors: [
            1, 4
        ]
    },

    {
        id: 4,
        name: "Laserové odstranění strií",
        text: `Pajizévky, neboli strie, jsou nepravé jizvičky na kůži, většinou v partiích břicha, hýždí a prsou, které vznikají ztrátou pružnosti kůže při rychlém přírůstku objemu v dané lokalitě v období těhotenství nebo při růstu. Vyskytují se převážně u žen. <br/>
           Většina odborníků se shoduje v tom, že odstranění strií je téměř neřešitelný úkol. V našem LLC však máme dobré zkušenosti s unikátním přístrojem N-lite, který má schopnost vyvolat v kůži novotvorbu kolagenu. Tím dokáže kůži ztracenou pružnost znovu vrátit a jemné strie vyhladit. Hrubší strie se zákrokem viditelně zlepší. Ošetření je nutné opakovat minimálně 2-3x. Provádí se ambulantně a je téměř bezbolestné. Bezprostředně po něm jsou strie červené, ale zarudnutí se ztrácí během několika hodin. Efekt po ošetření metodou N-lite se dostaví za 6-8 týdnů. Léčbu kombinujeme s místním ošetřováním strií speciálními krémy z řady retinoidů a to po dobu 6 měsíců až 1 roku. <br/><br/>
           <h3>METODY</h3><br>
           N-lite, Frakciovaný resurfacing a masáže`,
        types: [
            {
                name: "Metoda N-lite (dle počtu pulzů)",
                price: "2 000 - 6 000 Kč",
            },
        ]
    },

    /*{
        id: 5,
        name: "Vyhlazení vrásek metodou laserového resurfacingu",
        text: `<strong>Frakcionované lasery</strong> patří do skupiny <strong>rejuvenační</strong> (omlazující). Jsou určeny k odstranění známek stárnutí, vyhlazení jizev (i po akné), odstranění vrásek a pigmentací. Jsou schopny zmírnit pórovitost a ochablost pleti a sjednotit její barevný tón. <br/>
           Na rozdíl od klasického laseru je paprsek frakcionovaného laseru rozštěpen do mnoha tenkých paprsků, které jsou schopny pronikat hluboko do kůže. Okolo každého mikroskopického místa ošetření je ponechána oblast nepoškozené tkáně, což velmi výrazně urychluje hojení. Díky této technologii může být dosaženo efektu téměř srovnatelného s klasickým <strong>resurfacingem</strong> (výbrusem). Doba hojení i případná rizika jsou však minimální. <br/>
           Nejčastěji se ošetřuje obličej. Lze však ošetřit pouze jeho část, tvář s jizvami po akné, okolí očí nebo úst s jemnými vráskami. Lze ošetřit i oblast dekoltu nebo horní strany rukou. <br/>
           Zákrok se provádí v lokální anestezii, což obnáší hodinu až hodinu a půl před výkonem nanést znecitlivující mast. Samotný laserový výkon na obličeji pak trvá přibližně 30 - 45 minut. Na citlivějších částech obličeje může klient pociťovat pálení, záleží na nastavené intenzitě laseru a na citlivosti kůže. Po ošetření se místo ihned chladí. Doba hojení je od 2 - 7 dnů. Nejprve je kůže začervenalá, postupně dojde k problednutí neošetřených míst a naopak lehkému ztmavnutí míst vniku laserového paprsku do kůže. Na kůži jsou viditelné drobné hnědavé tečky, které se postupně odloupnou. Pokožku je třeba chránit před sluncem alespoň 2-3 měsíce po ošetření. <br/>
           Zákrok se neprovádí v těhotenství a u osob, které mají sklon k tvorbě keloidních jizev. Velké opatrnosti je třeba u lupenky nebo vitiliga. Po zhojení ale proces nekončí. Remodelace a produkce kolagenu v hloubce přetrvává až 3 měsíce a po celou dobu dochází k postupnému vypínání kůže.
           Frakcionovaný resurfacing je nejjemnější ošetření, provádí se v Emla anestezii (lokální znecitlivění) a nebo v krátké celkové anestezii - analgosedace (umělý spánek).`,
        types: [
            {
                name: "Frakcionovaný resurfacing - celý obličej",
                price: "15 000 Kč",
            }, {
                name: "Frakcionovaný resurfacing - 2/3 obličeje",
                price: "10 000 Kč",
            }, {
                name: "Frakcionovaný resurfacing - 1/3 obličeje",
                price: "5 000 Kč",
            }, {
                name: "Frakcionovaný resurfacing - dekolt",
                price: "6 000 - 8 000 Kč",
            }, {
                name: "Frakcionovaný resurfacing - obě ruce",
                price: "3 000 - 6 000 Kč",
            }, {
                name: "Frakcionovaný resurfacing - 1 cm2",
                price: "200 Kč",
            },
        ]
    },*/
]



// WEBPACK FOOTER //
// ./src/texts/czech/procedures/procedures_2.js